if (!customElements.get('dvn-hero-slider')) {
  class DvnHeroSlider extends HTMLElement {
    constructor() {
      super();
      this.current = 0;
      this.timer = null;
      this.userPaused = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-dvn-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dvn-dot]'));
      this.pauseButtons = Array.from(this.querySelectorAll('[data-dvn-pause]'));
      this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.speed = Math.max(3, Number(this.dataset.speed || 5)) * 1000;
      this.pauseLabel = this.pauseButtons[0]?.getAttribute('aria-label') || 'Pause slideshow';
      this.playLabel = this.pauseButtons[0]?.dataset.playLabel || 'Play slideshow';

      this.addEventListener('click', this.onClick);
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => {
        if (!this.contains(document.activeElement)) this.start();
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      });

      this.setActive(0);
      if (this.reducedMotion) this.setPaused(true);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const pause = event.target.closest('[data-dvn-pause]');
      if (pause && this.contains(pause)) {
        event.preventDefault();
        this.setPaused(!this.userPaused);
        return;
      }

      const prev = event.target.closest('[data-dvn-prev]');
      if (prev && this.contains(prev)) {
        event.preventDefault();
        this.goTo(this.current - 1);
        return;
      }

      const next = event.target.closest('[data-dvn-next]');
      if (next && this.contains(next)) {
        event.preventDefault();
        this.goTo(this.current + 1);
        return;
      }

      const dot = event.target.closest('[data-dvn-dot]');
      if (dot && this.contains(dot)) {
        event.preventDefault();
        const index = Number(dot.dataset.dvnDot);
        if (!Number.isNaN(index)) this.goTo(index);
      }
    }

    setPaused(paused) {
      this.userPaused = paused;
      this.pauseButtons.forEach((button) => {
        button.classList.toggle('is-paused', paused);
        button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        button.setAttribute('aria-label', paused ? this.playLabel : this.pauseLabel);
      });
      if (paused) this.stop();
      else this.start();
    }

    start() {
      this.stop();
      if (!this.autoplay || this.userPaused || this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.goTo(this.current + 1), this.speed);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    goTo(index) {
      const total = this.slides.length;
      if (!total) return;
      const next = ((index % total) + total) % total;
      this.setActive(next);
      if (!this.userPaused) this.start();
    }

    setActive(index) {
      this.current = index;
      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      this.dots.forEach((dot) => {
        const active = Number(dot.dataset.dvnDot) === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('dvn-hero-slider', DvnHeroSlider);
}
